import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import UserMenu from './userMenu'
import Toast from './sub_components/toast'
import * as openBetsService from '../services/openBetsService'
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import * as dateUtil from '../util/date.util'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import * as _ from 'lodash'
import * as authUtil from "../util/auth.util";
class OpenBets extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            accounts: '',
            betstatus: "Matched",
            bets_data: [],
            bets_search_data: [],
            csv_json: [],
            pdf_json: [],
            last_id: "",
            first_id: "",
            action: "",
            from: "",
            to: "",
            page_no: 1,
            count_records: 0,
            records_per_page: 25,
            amount_from: 0.0,
            amount_to: 0.0,
            showToast: false,
            toastMsg: "",
            toastType: "",
            showData: false,
            loader: false,
            isMaintanance: false
        };
    }
    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){ 
            authUtil.logout();
        }
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ accounts: userData.sub, to: curDate, from: weekDate, bets_data: [] })
    }
    parseToPickerDate(date) {
        let dtArr = date.split("/")
        let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
        return dt
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }
    parseFilterBody() {
        let betstatus = this.state.betstatus
        if (betstatus === "Matched") {
            betstatus = ["PLACED"]
        }
        else if (betstatus === "UnMatched") {
            betstatus = ["REQUESTED", "REJECTED"]
        }
        else {
            betstatus = [""]
        }
        // let body = {
        //     "filters": {
        //         "accounts": this.state.accounts,
        //         "amount_from": 0,
        //         "amount_to": 0,
        //         "betstatus": betstatus
        //     },
        //     "last_id": this.state.last_id,
        //     "first_id": this.state.first_id,
        //     "action": this.state.action,
        //     "from": new Date(this.state.from).toISOString(),
        //     "to": new Date(this.state.to).toISOString(),
        //     "zone": new Date().getTimezoneOffset(),
        //     "page_no": this.state.page_no,
        //     "records_per_page": this.state.records_per_page,
        //     "count_records": this.state.count_records,
        // }
        let body = {
            "lastId": this.state.last_id,
            "firstId": this.state.first_id,
            "action": this.state.action,
            "from": new Date(this.state.from).toISOString(),
            "to": new Date(this.state.to).toISOString(),
            "pageNo": this.state.page_no,
            "recordsPerPage": this.state.records_per_page
        }
        body = this.clean(body);
        return body
    }
    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        this.setState({ loader: true })
        await openBetsService.postOpenBets(body).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        bets_data: [],
                        bets_search_data: [],
                        last_id: res.lastId,
                        first_id: res.firstId,
                        action: res.action,
                        page_no: res.pageNo,
                        records_per_page: res.recordsPerPage,
                        count_records: res.countRecords,
                        showData: true,
                    }, () => {
                        this.setState({
                            bets_data: res.items,
                            bets_search_data: res.items,
                            loader: false
                        })
                    }
                );
            } else {
                this.setState({ bets_data: [], bets_search_data: [], showData: true, loader: false, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, amount_from: 0, amount_to: 0 })
            }
        })
    }
    async onDownload() {
        const self = this;
        this.setState({ csv_json: [] }, () => {
            let order = this.state.bets_search_data
            let items = []
            let dictinory = {}
            for (let x of order) {
                dictinory = {}
                let st = x["createdAt"].split(" ")
                let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                let dt = new Date(dtstr).toLocaleString("en-IN")
                dictinory["Date"] = dt
                dictinory["Competition"] = x["competitionName"]
                dictinory["Event"] = x["eventName"]
                dictinory["Market"] = x["marketName"]
                dictinory["Runner"] = x["runnerName"]
                if (x["side"] === 0) {
                    dictinory["Side"] = "Back"
                }
                else if (x["side"] === 1) {
                    dictinory["Side"] = "Lay"
                }
                else if (x["side"] === -1) {
                    dictinory["Side"] = "Unknown"
                }
                else {
                    dictinory["Side"] = "-"
                }
                if (x["marketBettingType"] === "LINE") {
                    dictinory["Line"] = x["runnerId"]
                }
                else {
                    dictinory["Line"] = "-"
                }
                dictinory["Rate"] = x["price"]
                dictinory["Amount"] = x["amount"]
                if (x["eventTypeId"] !== "99") {
                    dictinory["Potential Profit"] = x["potentialProfit"]
                    dictinory["Potential Loss"] = x["potentialLoss"]
                }
                else {
                    dictinory["Potential Profit"] = "-"
                    dictinory["Potential Loss"] = "-"
                }
                items.push(dictinory)
            }
            this.setState({ csv_json: items }, () => {
                setTimeout(function () {
                    self.csvLink.current.link.click();
                }, 500)
            })
        })
    }
    async onPDFDownload() {
        this.setState({ pdf_json: [] }, () => {
            this.setState({ pdf_json: this.state.bets_search_data }, () => {
                setTimeout(function () {
                    printJS({
                        printable: 'printJS-div',
                        type: 'html',
                        targetStyles: ['*']
                    })
                }, 500)
            })
        })
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    onAction(e) {
        const value = e.target.name;
        let page_n = 0;
        if (value === "next") {
            page_n = this.state.page_no + 1;
        }
        if (value === "prev") {
            page_n = this.state.page_no - 1;
        }
        this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });
    }
    resetForm() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ from: weekDate, to: curDate, showData: false, records_per_page: 25, betstatus: "Matched", bets_data: [], bets_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, amount_from: 0, amount_to: 0 })
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
            this.props.notify("Date range must be 1 month.", "error")
        }
        else {
            this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
        }
    }
    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;

        if (name === "records_per_page" || name === "records_display") {
            this.setState({ [name]: value, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 }, () => { this.submitForm() });
        }
        else {
            this.setState({ [name]: value });
        }
    }
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    onSearch(e) {
        const value = e.target.value;
        if (this.state.bets_search_data) {
            let bets_lst = _.filter(this.state.bets_search_data, function (obj) {
                return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ bets_data: [] }, () => {
                this.setState({ bets_data: bets_lst });
            })
        }
    }
    render() {
        let page_no = parseInt(this.state.page_no)
        let count_records = parseInt(this.state.count_records)
        let records_per_page = parseInt(this.state.records_per_page)
        let current_record = 0
        let total_record = 0
        let start_record = 0
        if (count_records > (records_per_page * page_no)) {
            current_record = records_per_page * page_no
            total_record = count_records
            start_record = current_record - (records_per_page - 1)
        } else if (this.state.bets_data.length > 0) {
            current_record = count_records
            total_record = count_records
            start_record = ((page_no - 1) * records_per_page) + 1
        }
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Unsettled Bet</p>
                            </div>
                            <div className="allreport col3">
                                <div className="row mx-0">
                                    {/* <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mt-2">
                                        <div className="form-group font-12">
                                            <select onChange={(e) => this.onChange(e)} title="Bet Status" className="form-control" name="betstatus" value={this.state.betstatus}>
                                                <option value="Matched">Matched</option>
                                                <option value="UnMatched">Un-Matched</option>
                                            </select>
                                        </div>
                                    </div> */}
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.from}
                                                onChange={(e) => this.onDateTimeChange("from", e)}
                                                id="from_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.to}
                                                onChange={(e) => this.onDateTimeChange("to", e)}
                                                id="to_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                            <button className="btn place-bet-btn" onClick={(e) => this.onSubmit(e)}>Go</button>
                                            <button className="btn place-bet-btn ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                                {!this.state.showData && !!this.state.loader ? <div className={"ml-2"}>Loading......</div> : null}
                                {!!this.state.showData && <div>
                                    <div className="row text-center mt-2 mx-0 px-1">

                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 mt-1 px-2">
                                            <div className="d-flex float-left">
                                                <div className="form-group mb-0 d-inline">
                                                    <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                                </div>
                                                <CSVLink
                                                    data={this.state.csv_json}
                                                    filename={"UnsettledBets-Report.csv"}
                                                    asyncOnClick={true}
                                                    className="d-none"
                                                    ref={this.csvLink}>
                                                </CSVLink>
                                                <button className="btn btn-sm d-inline csv-icon p-0" title="Export CSV" onClick={(e) => this.onDownload(e)} disabled={this.state.bets_data.length > 0 ? false : true}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/csv-icon.svg"}></img></button>
                                                <div style={{ display: "none" }}>
                                                    <div id="printJS-div">
                                                        <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }}>
                                                            <thead>
                                                                <tr className="bg-dark text-white">
                                                                    <th className="wid200 text-left pthead">Date</th>
                                                                    <th className="wid150 text-left pthead">Competition</th>
                                                                    <th className="wid280 text-left pthead">Event</th>
                                                                    <th className="wid150 text-left pthead">Market</th>
                                                                    <th className="wid140 text-left pthead">Runner</th>
                                                                    <th className="wid100 text-left pthead">Side</th>
                                                                    <th className="wid100 text-right pthead">Line</th>
                                                                    <th className="wid100 text-right pthead">Rate</th>
                                                                    <th className="wid100 text-right pthead">Amount</th>
                                                                    <th title="Potential Profit" className="wid100 text-right pthead">PP</th>
                                                                    <th title="Potential Loss" className="wid100 text-right pthead">PL</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style={{ display: "none" }}>
                                                                    <td colSpan="9" className="text-center"><h5 className="text-danger font-weight-bold m-0">No Bets</h5></td>
                                                                </tr>
                                                                {this.state.pdf_json.length > 0 ? this.state.pdf_json.map((order, i) => {
                                                                    let st = (order.createdAt).split(" ")
                                                                    let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                                    let dt = new Date(dtstr).toLocaleString("en-IN")
                                                                    let price = order.price
                                                                    if(price.toString().indexOf('.') > -1){
                                                                        price = price.toFixed(2);
                                                                    }
                                                                    return (
                                                                        <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : "#FFFFFF"}>
                                                                            <td className="text-left">{dt ? dt : "-"}</td>
                                                                            <td className="text-left">{!!order.competitionName ? order.competitionName : "-"}</td>
                                                                            <td className="text-left">{!!order.eventName ? order.eventName : "-"}</td>
                                                                            <td className="text-left">{!!order.marketName ? order.marketName : "-"}</td>
                                                                            <td className="text-left">{!!order.runnerName ? order.runnerName : "-"}</td>
                                                                            <td className="text-left">{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                                            <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                                            <td className="text-right fbold">{!!price ? price : "-"}</td>
                                                                            <td className="text-right fbold">{!!order.amount ? <Currency classPropName={"fbold"} amount={order.amount} showColor={false} /> : "0"}</td>
                                                                            {order.eventTypeId !== "99" ?
                                                                                <td className="text-right fbold">{!!order.potentialProfit ? <Currency classPropName={"fbold"} amount={order.potentialProfit} showColor={true} /> : "0"}</td>
                                                                                : <td className="text-right">{order.provider === 'LUDOCRICKET' ? <Currency classPropName={order.betStatus === "WON" ? "text-success fbold" : order.betStatus === "LOST" ? "text-danger fbold" : "fbold"} amount={order.potentialProfit} showColor={false} /> : '-'}</td>
                                                                            }
                                                                            {order.eventTypeId !== "99" ?
                                                                                <td className="text-right fbold">{!!order.potentialLoss ? <Currency classPropName={"fbold"} amount={order.potentialLoss} showColor={true} /> : "0"}</td>
                                                                                : <td className="text-right">-</td>
                                                                            }
                                                                        </tr>
                                                                    );
                                                                }) : <tr style={{ display: "none" }}>
                                                                    <td colSpan={15} className="text-center"><h5 className="text-danger font-weight-bold m-0">No Bets</h5></td>
                                                                </tr>}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <button className="btn btn-sm pdf-icon d-inline p-0" title="Export PDF" onClick={(e) => this.onPDFDownload(e)} disabled={this.state.bets_data.length > 0 ? false : true}>
                                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/pdf-icon.svg"}></img>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <span className="d-inline search-report ml-2">entries</span>
                                            <div className="form-group font-12 float-right mb-0">
                                                <select onChange={(e) => { this.onChange(e) }} className="form-control" name="records_per_page" value={this.state.records_per_page}>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                            <span className="d-inline search-report">Show</span>
                                        </div>
                                    </div>
                                    <div className="dt-responsive table-responsive account-statment p-2">
                                        <table id="basic-btn" className="table table-bordered table-sm mb-1 addpadding nowrap">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th className="pthead">Date</th>
                                                    <th className="dtwidth pthead">Competition</th>
                                                    <th className="wid280 pthead">Event</th>
                                                    <th className="dtwidth pthead">Market</th>
                                                    <th className="wid140 pthead">Runner</th>
                                                    <th className="wid100 pthead">Side</th>
                                                    <th className="wid100 text-right pthead">Line</th>
                                                    <th className="wid100 text-right pthead">Rate</th>
                                                    <th className="wid100 text-right pthead">Amount</th>
                                                    <th title="Potential Profit" className="wid100 text-right pthead">PP</th>
                                                    <th title="Potential Loss" className="wid100 text-right pthead">PL</th>
                                                </tr>
                                            </thead>
                                            <tbody id="tblAccountStatement">
                                                {!!this.state.loader ?
                                                    <tr>
                                                        <td colSpan={17} className="text-center py-5">
                                                            <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                        </td>
                                                    </tr> :
                                                    this.state.bets_data.length > 0 ? this.state.bets_data.map((order, i) => {
                                                        let st = (order.createdAt).split(" ")
                                                        let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                        let dt = new Date(dtstr).toLocaleString("en-IN")
                                                        let price = order.price
                                                        if(price.toString().indexOf('.') > -1){
                                                            price = price.toFixed(2);
                                                        }
                                                        if(order.eventTypeId === '300'){
                                                            order.market_time =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                        }
                                                        let competitionName = order.competitionName ? (order.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(order.competitionName) : order.competitionName) : "-"
                                                        return (
                                                            <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                                <td className="" title={dt ? dt : "-"}>{dt ? dt : "-"}</td>
                                                                <td className="dtwidth" title={competitionName}>{competitionName}</td>
                                                                <td className="wid280" title={!!order.eventName ? order.eventName : "-"}>{!!order.eventName ? order.eventName : "-"}</td>
                                                                <td className="" title={!!order.marketName ? order.marketName : "-"}>{order.eventTypeId === '300' && !!order.market_time && order.market_time.length > 0 ? 
                                                            <>
                                                            {order.market_time[0] }
                                                            <span className=''> [<b>{(order.market_time.length > 0 ? order.market_time[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                                <td>{!!order.runnerName ? order.runnerName : "-"}</td>
                                                                <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                                <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                                <td className="text-right fbold">{!!price ? price : "-"}</td>
                                                                <td className="text-right fbold">{!!order.amount ? <Currency classPropName={"fbold"} amount={order.amount} showColor={false} /> : "0"}</td>
                                                                {order.eventTypeId !== "99" ?
                                                                    <td className="text-right fbold">{!!order.potentialProfit ? <Currency classPropName={"fbold"} amount={order.potentialProfit} showColor={true} /> : "0"}</td>
                                                                    : <td className="text-right">{order.provider === 'LUDOCRICKET' ? <Currency classPropName={order.betStatus === "WON" ? "text-success fbold" : order.betStatus === "LOST" ? "text-danger fbold" : "fbold"} amount={order.potentialProfit} showColor={false} /> : '-'}</td>
                                                                }
                                                                {order.eventTypeId !== "99" ?
                                                                    <td className="text-right fbold">{!!order.potentialLoss ? <Currency classPropName={"fbold"} amount={order.potentialLoss} showColor={true} /> : "0"}</td>
                                                                    : <td className="text-right">-</td>
                                                                }
                                                            </tr>
                                                        );
                                                    }) : <tr>
                                                        <td colSpan={12} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Unsettled Bets</h5></td>
                                                    </tr>}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row mx-0 px-1 py-3">
                                        <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                                        <div className="col-12 col-sm-12 col-md-6">
                                            <div className="btn-group float-right" role="group" aria-label="Basic example" id="divpagecount">
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" ? true : false}>Prev</button>
                                                <button className="btn btn-blue" disabled>
                                                    {
                                                        this.state.page_no
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" ? true : false}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(OpenBets);